export const galeru_registration = [
  {
    ip1: "ब्यवसाय रहने ठेगाना",
    type: "text",
    name: "company_address",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
  {
    ip1: "ब्यवसायधनिको नाम",
    type: "text",
    name: "owner_name",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
  {
    ip1: "ब्यवसायधनिको ठेगाना",
    type: "text",
    name: "owner_address",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },

  {
    ip1: "सम्बन्धित ब्यक्तीको नाम",
    type: "text",
    name: "contact_person",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
  {
    ip1: "सम्बन्धित ब्यक्तीको सम्पर्क नं.",
    type: "number",
    name: "contact_number",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
  {
    ip1: "लगानी गर्ने जम्मा पुँजी रकम",
    type: "number",
    name: "total_capital",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
];
export const Gharelu_details_of_shareholder = [
  {
    ip1: "क्र. स.",
    // type: "text",
    name: "s.no",
    // validation: {
    //   required: {
    //     value: true,
    //     message: "this field is mandatory",
    //   },
    // },
  },
  {
    ip1: "साझेदार सदस्यहरुको नाम",
    type: "text",
    name: "name",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
  {
    ip1: "  हालको ठेगाना",
    type: "text",
    name: "address",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },

  {
    ip1: " लगानी गर्ने शेयरको प्रतिशत",
    type: "number",
    name: "amount",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
  {
    ip1: "लगानी गर्ने शेयर रकम",
    type: "number",
    name: "share_amount",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
  {
    ip1: " शेयर सदस्यको नागरिकता",
    type: "file",
    name: "citizenship",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
  {
    ip1: "पासपोर्ट साईजको फोटो",
    type: "file",
    name: "pp_size_photo",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
];

export const ghaleru_shareholder =  Gharelu_details_of_shareholder.filter(item=> item.name !=="s.no").reduce((a,v)=>({...a, [v.name]:""}),{})






export const Gharelu_upload_details = [
  {
    ip1: "ब्यवसायीधनिको नागरिकता",
    sn: 1,
    remark: "",
  },
  {
    ip1: "घरबेटीको नागरिकता (यदि सटर तथा कोठाभाडामा लिएर ब्यवसाय गर्ने भएमा)",
    sn: 2,
    remark: "",
  },
  {
    ip1: "ब्यवसाय रहने जग्गाको लालपुर्जा",
    sn: 3,
    remark: "",
  },
  {
    ip1: "घरभाडा सम्झौता पत्र वा मञ्जुरीनामा पत्र",
    sn: 4,
    remark: "",
  },
  {
    ip1: "ब्यवसाय साझेदारी भएमा साझेदारी कबुलियतनामा",
    sn: 5,
    remark: "",
  },
  {
    ip1: "अन्य........................ पासपोर्ट साईजको फोटो",
    sn: 6,
    remark: "",
  },
];

export const Gharelu_upload_details_v2 = [
  {
    ip1: "ब्यवसायीधनिको नागरिकता",
    sn: 1,
    remark: "",
  },
  {
    ip1: "घरबेटीको नागरिकता (यदि सटर तथा कोठाभाडामा लिएर ब्यवसाय गर्ने भएमा)",
    sn: 2,
    remark: "",
  },
  {
    ip1: "ब्यवसाय रहने जग्गाको लालपुर्जा",
    sn: 3,
    remark: "",
  },
  {
    ip1: "घरभाडा सम्झौता पत्र वा मञ्जुरीनामा पत्र",
    sn: 4,
    remark: "",
  },
  {
    ip1: "चारकिल्ला प्रमाणित भएको मुचुल्का",
    sn: 5,
    remark: "",
  },
  {
    ip1: "वडा कार्यालयले दिईएको दर्ता सिफारिस पत्र",
    sn: 6,
    remark: "",
  },
  {
    ip1: "वफरजन एरियामा पर्ने भए वन वा निकुन्जको सिफारिस",
    sn: 7,
    remark: "",
  },
  {
    ip1: "ब्यवसाय साझेदारी भएमा साझेदारी कबुलियतनामा",
    sn: 8,
    remark: "",
  },
  {
    ip1: "अन्य........................",
    sn: 9,
    remark: "",
  },
];
